import React, { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { loginRequest } from '../../Common/requests'
import { useNavigate } from 'react-router-dom';
import { HOME_PAGE } from '../../Common/constants';
import { usePostHog } from '@posthog/react';

import ArrowSVG from '../../assets/icons/arrow-up.svg'
import SimpleReactValidator from "simple-react-validator";
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';

const Login = () => {
    const { t } = useTranslation('marketplace');
    const posthog = usePostHog();

    const [login, setLogin] = useState(false);
    const [validator] = useState(new SimpleReactValidator());
    const [disabled, setDisabled] = useState(false);
    const [, forceUpdate] = useState();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const handleLogin = async (evt) => {
        if (typeof evt !== "undefined" && evt != null) {
            evt.preventDefault();
        }

        if (!validator.allValid()) {
            validator.showMessages();
            forceUpdate(1);
            setDisabled(false);
        } else {
            setDisabled(true);
            let data = { email: username, password: password };
            let result = await loginRequest(data);
            if (result && result.success) {
                posthog?.identify(String(result.user.id), {
                    name: `${result.user.firstName} ${result.user.lastName}`,
                });
                posthog?.capture('user_logged_in');
                navigate(HOME_PAGE);
            } else {
                setDisabled(false);
            }
        }
    }

    return (
        <div className="auth-page">
            <div className="container">
                <div className="block-content inner-head">
                    <Link className="icon" to="/">
                        <ReactSVG src={ArrowSVG} />
                    </Link>
                    {/* <img src={process.env.PUBLIC_URL + SiteLOGO} alt="img" /> */}
                </div>
                {login ?
                    <div className="block-content content-holder">
                        <form onSubmit={handleLogin} noValidate>
                            <div className="form-group">
                                <label>{t('auth.username')}</label>
                                <input type="text" className="form-control" placeholder={t('auth.username')} value={username} onChange={(e) => { setUsername(e.target.value) }} />
                                {validator.message(
                                    "username",
                                    username,
                                    "required",
                                    { className: "text-danger" }
                                )}
                            </div>
                            <div className="form-group">
                                <label>{t('auth.password')}</label>
                                <input type={showPassword ? "text" : "password"} className="form-control" placeholder={t('auth.password')} value={password} onChange={(e) => { setPassword(e.target.value) }} />
                                {validator.message(
                                    "password",
                                    password,
                                    "required",
                                    { className: "text-danger" }
                                )}
                                <span className="form-icon" onClick={()=>setShowPassword(!showPassword)}>
                                   {showPassword ? <AiFillEye/>  : <AiFillEyeInvisible/>}
                                </span>
                            </div>
                            <Link to="/forgot-password" className="link text-right">{t('auth.forgotPassword')}</Link>
                            <div className="button-holder mt-3">
                                <button type="submit" className="btn btn-secondary" disabled={disabled}>{t('auth.login')}</button>
                            </div>
                        </form>
                        <div className="text-center mt-3">
                            <h6 className="text-grey">{t('auth.noAccount')}</h6>
                            <Link className="link" to="/signup">{t('auth.signupNow')}</Link>
                        </div>
                    </div>
                    :
                    <div className="block-content content-holder">
                        <div className="">
                            <h5>{t('auth.login')}</h5>
                            <h6 className="text-grey">{t('auth.loginSubheading')}</h6>
                        </div>
                        <div className="buttons-group">
                            <button className="btn btn-secondary" onClick={() => setLogin(!login)}>{t('auth.logIn')}</button>
                            {/* <button className="btn btn-social">
                                <div className="icon"><ReactSVG className="svg-icon" src={GoogleSVG} /></div>
                                Continue with Google
                            </button>
                            <button className="btn btn-social">
                                <div className="icon"><ReactSVG className="svg-icon fb-icon" src={FacebookImg} /></div>
                                Continue with Facebook
                            </button> */}
                        </div>
                        <div className="text-center">
                            <h6 className="text-grey">{t('auth.noAccount')}</h6>
                            <Link className="link" to="/signup">{t('auth.signupNow')}</Link>
                        </div>
                    </div>
                }
                {/* <div className="block-content content-holder">
                    <div className="text-center">
                        <h5>Login for businesses</h5>
                        <h6 className="text-grey">To access your business account please go to the<Link to="#" className="link">business login page</Link></h6>
                    </div>
                </div> */}
                <h6 className="text-grey text-center"> {t('auth.copyrightNotice')}</h6>
            </div>
        </div>
    );
}

export default Login;
